import React, {useContext, useEffect, useRef, useState} from "react";
import { Link } from "react-router-dom";
import "./news-page.scss";
import { News } from "../../components/News/News";
import { latestNews } from "../../TestData";
import Footer from "../../components/Footer/Footer";
import FIlter from "./Filter/FIlter";
import SearchBar from "../../components/SearchBar/SearchBar";
import EducareNavBar from "../../components/EducareNavBar/EducareNavBar";
import {getBlogItems} from "../../store/actions/adminActions";
import {useDispatch, useSelector} from "react-redux";
import Pagination from "../../components/Pagination/Pagination";
import {ErrorView} from "../Helpers/errorView";
import {getWalletActivity, getWalletBalance} from "../../store/actions/walletActions";
import {GhostExamListLoader} from "../../components/Loaders/GhostExamListLoader";
import {GhostExamListMobileLoader} from "../../components/Loaders/GhostExamListMobileLoader";
import {GhostBlogLoader} from "../../components/Loaders/GhostBlogLoader";
import {PrimaryButton} from "../../components/button";
import {toast} from "react-toastify";
import {ADMIN_ROLES, BUSINESS_ROLES, DEFAULT_ERROR, GET_BLOGS_EMAIl_URL, SEND_EMAIL_URL} from "../../api/urls";
import useApi from "../../hooks/useApi";
import {NavbarAdmin} from "../../components/Navbar/NavbarAdmin";
import {NavbarBusiness} from "../../components/Navbar/NavbarBusiness";
import {Navbar} from "../../components/Navbar/Navbar";
import AuthContext from "../../context/AuthProvider";
import dynamicComponent from "../../components/AdsenseExample/dynamicImport";
const AdsenseExample = dynamicComponent(() => import("../../components/AdsenseExample/AdsenseExample"));

export const NewsPage = () => {
  const { user, roles } = useContext(AuthContext);
  const isAdmin = roles?.find(role => ADMIN_ROLES?.includes(role));
  const isBusiness = roles?.find(role => BUSINESS_ROLES?.includes(role));
  const [currentPage, setCurrentPage] = useState(1);
  const [filterPage, setFilterPage] = useState("DEFAULT");
  const [searchPage, setSearchPage] = useState("");
  const [isSending, setIsSending] = useState(false);
  const emailInput = useRef(null);
  const dispatch = useDispatch();
  const pageSize = 6;
  const { blogsdata } = useSelector((state) => state.admin);
  const api = useApi();



  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleGotoFirstPage = () => {
    let Ppage = currentPage - 1;
    if(Ppage < 1)Ppage=1;
    setCurrentPage(Ppage);
    window.scrollTo({top: 0, left: 0, behavior: 'instant'});
  };
  const handleRefreshPage = (filter,isSearch=false) => {
    if(isSearch){
      setSearchPage(filter);
    }
    else{
      setFilterPage(filter);
    }

  };
  const handleGotoLastPage = (page) => {
    let Ppage = currentPage + 1;
    if(Ppage > page)Ppage=page;
    setCurrentPage(Ppage);
    window.scrollTo({top: 0, left: 0, behavior: 'instant'});
  };


  useEffect(() => {
    dispatch(getBlogItems({ pageSize, currentPage,sort: filterPage
      ,search: searchPage }));
    // console.log("useEffect others: ",currentPage, pageSize,filterPage);
  }, [currentPage, pageSize,filterPage,searchPage]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!emailInput.current.value) {
      toast.error("Email is required");
    }
    else{
      await sendMail({
        email: emailInput.current.value,
      });
    }
  }

  const sendMail = async (payload) => {
    try {
      // console.log("Payload: ",payload);
      setIsSending(true);
      const resp:any  = await api.post(GET_BLOGS_EMAIl_URL, payload);
      // console.log("Payload: ",resp);
      toast.success(
          resp.data.success
      );
      setIsSending(false);
    } catch (error) {
      toast.error(getErrorMessage(error));
      setIsSending(false);
    }
  };

  const getErrorMessage = (error) => {
    // console.log("error: ",error);
    let msg  = (error?.response?.status === 406 && error?.response?.data) || error.response.statusText;
    if(error?.response?.data && typeof error.response.data === 'object'
        && error.response.data.message){
      msg = error.response.data.message;
    }
    return (error?.response?.status !== 404 && msg) || DEFAULT_ERROR;
  };

  return (
    <>
      {!!!user?<EducareNavBar />:(isAdmin?(<NavbarAdmin />):(isBusiness ? <NavbarBusiness /> : <Navbar />))}
      <div className={"news-page-main"}>
        <div className="news-page">
          <center>
            <div className="col-md-5">
              {" "}
              <p>Our blog</p>
              <h1>Our Resources</h1>
              <p>
                Subscribe to learn about our new product features, latest on our
                exams platform, solutions and updates.
              </p>
            </div>
          </center>
          <div className="d-flex offset-md-4 col-md-4 mt4">
            <input placeholder="Enter your email" ref={emailInput}/>
            {/*<button>Subscribe</button>*/}
            <PrimaryButton onClick={handleSubmit} isLoadingMsg="Subscribing. Please wait..."
                           size="sm"
                           className=""
                           isLoading={isSending}>Subscribe</PrimaryButton>
          </div>
        </div>
        <div className="flexy col-md-10 offset-md-1">

          <div className="col-md-3 ">
            {" "}
            <SearchBar callback={handleRefreshPage}  />
          </div>
          <div className=" flexy flexyM offset-md-7 col-md-2">
            <FIlter callback={handleRefreshPage}  />
          </div>
        </div>
        {blogsdata.loadingBlog &&
        Array(pageSize)
            .fill()
            .map((item, index) => {
              return (
                  <React.Fragment key={index}>
                    <GhostBlogLoader></GhostBlogLoader>
                  </React.Fragment>
              );
            })}
        {!blogsdata.loadingBlog && blogsdata.blogs && (
            <>
              <div className="row row-cols-1 row-cols-lg-2  g-lg-2 col-md-10 offset-md-1 mt2">
                {blogsdata.blogs && (
                    <>
                      {blogsdata.blogs.map((data, index) => (
                          <News blog={data} key={data.id} />
                      ))}
                    </>
                )}
              </div>
              <div className="col-md-10 offset-md-1 mt4 npage">
                {blogsdata.blogs && (
                    <center>
                      <Pagination
                          itemsCount={blogsdata?.meta?.totalItems}
                          pageSize={pageSize}
                          onPageChange={handlePageChange}
                          onGotoLastPage={handleGotoLastPage}
                          onGotoFirstPage={handleGotoFirstPage}
                          currentPage={currentPage}
                          isShowDetail={false}
                      />
                    </center>
                )}
                {(!blogsdata.blogs || !blogsdata.blogs.length) && <ErrorView />}
                <AdsenseExample />
              </div>
              <div className="col-md-8 offset-md-2 flexy prefooter mt">
                <div className="col-md-6">
                  <h1>
                    Start Your
                    <br /> Exam Journey Now ⚡︎
                  </h1>
                  <p>
                    Embrace the power of technology and learning and let's help you ace
                    your exams
                  </p>
                </div>
                <div className="col-md-3 offset-md-3">
                  <Link to={"/authenticate"}>
                    <button>Join Now</button>
                  </Link>
                </div>
              </div>
            </>
        )}

      </div>
      <Footer />
    </>
  );
};
